import React from 'react';
import { uniqueId, isEmpty } from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useClientContext } from '@bingads-webui-campaign-react/smart-page-context';
import { withErrorView } from '@bingads-webui-campaign-react/smart-page-error-boundary';
import { SmartHeader, useActionButtons } from '@bingads-webui-campaign-react/smart-component-header';

const getStyles = (components = {}, { palette = {} }) => ({
  footerContainer: {
    height: 50,
    lineHeight: '50px',
    borderTop: '1px solid #C4C4C4',
    marginLeft: 33,
    marginRight: 33,
    display: 'flex',
  },
  footerContainerMobile: {
    marginBottom: components.fixedMobileFooter.height,
    marginLeft: 11,
    marginRight: 11,
  },
  footerContainerMobileForBlankBanner: {
    marginLeft: 11,
    marginRight: 11,
  },
  text: {
    marginLeft: 'auto',
    marginRight: 3,
    fontSize: 16,
    color: palette.footer,
  },
  mobileText: {
    marginRight: 'auto',
  },
});

export const UnStyledSmartFooterView = ({
  classes,
  i18n,
  id,
  rootId,
  disabled,
}) => {
  const { isMobile } = useClientContext();
  const actionButtons = useActionButtons();

  let footerContainerMobileClass = null;
  if (isMobile) {
    if (isEmpty(actionButtons)) {
      footerContainerMobileClass = classes.footerContainerMobileForBlankBanner;
    } else {
      footerContainerMobileClass = classes.footerContainerMobile;
    }
  }

  return (
    <footer id={id} >
      <div
        className={classnames(classes.footerContainer, footerContainerMobileClass)}
      >
        <span
          className={classnames(classes.text, isMobile && classes.mobileText)}
        >
          {i18n.getString(_TL_('Powered by Microsoft Advertising'))}
        </span>
      </div>
      {
        isMobile &&
        <SmartHeader
          id={uniqueId('mobile_footer_')}
          rootId={rootId}
          disabled={disabled}
          footerSplit
        />
      }
    </footer>
  );
};

UnStyledSmartFooterView.propTypes = {
  classes: PropTypes.shape({
    footerContainer: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  rootId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export const SmartFooterView = withErrorView(withDefaultStyles(
  UnStyledSmartFooterView,
  getStyles
), 'componentMode');
